export default {
  // request_url:'http://tzvtcweb.cjnep.net/promotion/web/'
  // request_url:'http://git-tzvtc.cjnep.net/promotion/web/',
  // request_url_sims:'http://git-tzvtc.cjnep.net/sims/web/',
}



//////////////////
// WEBPACK FOOTER
// ./static/conf.js
// module id = null
// module chunks = 